import { Injectable } from '@angular/core';
import { ApiAuthService } from './api-auth.service';
import { ToTypeOrm } from '../models/_to-type-orm.schema';
import { TeamLeader } from '../models/team-leader.schema';

@Injectable({
  providedIn: 'root'
})
export class TeamLeaderService extends ApiAuthService {

  private readonly url = `${this.baseUrl}/team-leader`;

  async getAllTeamLeaders(page?: number, limit?: number, order?: {}, filter: any = {}): Promise<any> {
    return this.getAll(page, limit, order, filter);
  }

  async getAll(page?: number, limit?: number, order?: {}, filter?: { [key: string]: ToTypeOrm }): Promise<any>{
    let params = {};
    if (page) params['page'] = page;
    if (limit) params['limit'] = limit;
    if (order) params['order'] = JSON.stringify(order);
    if (filter) params['filter'] = JSON.stringify(filter);
    return this.request(() => this.http.get(`${this.url}`, { params: params }).toPromise() );
  }

  async getOne(id: string|number): Promise<TeamLeader> {
    return this.request(() => this.http.get<TeamLeader>(`${this.url}/${id}`).toPromise());
  }

  async getOneWithTimeAvailability(id: string|number): Promise<TeamLeader> {
    return this.request(() => this.http.get<TeamLeader>(`${this.url}/${id}/with-time-ava`).toPromise());
  }

  async create(teamLeaderParams: TeamLeader): Promise<TeamLeader> {
    let body = teamLeaderParams;
    return this.request(() => this.http.post<TeamLeader>(`${this.url}`, body).toPromise());
  }

  async update(id: number, teamLeaderParams: TeamLeader): Promise<TeamLeader> {
    let body = teamLeaderParams;
    return this.request(() => this.http.put<TeamLeader>(`${this.url}/${id}`, body).toPromise());
  }

  async updateMe(teamLeaderParams: TeamLeader): Promise<TeamLeader> {
    let body = teamLeaderParams;
    return this.request(() => this.http.put<TeamLeader>(`${this.url}`, body).toPromise());
  }

  async delete(id: number): Promise<{ id: number, success: boolean }> {
    return this.request(() => this.http.delete<{ id: number, success: boolean }>(`${this.url}/${id}`).toPromise());
  }

}
